import { Col, Row } from "antd";
import React from "react";

export interface PageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

export const PageHeader = (props: PageHeaderProps) => {
  return (
    <Row
      style={{
        marginTop: "10px",
        marginBottom: "10px",
        paddingBottom: "8px",
      }}
    >
      <Col flex="auto">
        <div style={{ fontSize: "large", fontWeight: "bolder" }}>
          {props.title}
        </div>
      </Col>
      <Col flex="right">{props.children}</Col>
    </Row>
  );
};
